export enum Feature {
  badges,
}



// WEBPACK FOOTER //
// ./src/common/features/Feature.ts